import React, { useContext } from 'react';
import { ChatbotContext } from '../../Context/ChatbotContext';
import { ChatbotStateContext } from '../../Context/ChatbotStateContext';
import ImgWelcome from '../../assets/chatbot/img_Welcome.svg';
import { IoMdCloseCircle } from 'react-icons/io';
import logoblanco from '../../assets/chatbot/Logo_B2.svg';

const Welcome = () => {
  const { isChatOpen, toggleChat } = useContext(ChatbotContext);
  const { setCurrentStep, userId, sessionId } = useContext(ChatbotStateContext);

  return (
    <div
      id="chatbot-container"
      className={`chatbot-container ${isChatOpen ? 'chatbot-expanded' : ''}`}
    >
      {/* Contenedor del botón cuando el chatbot está cerrado */}
      {!isChatOpen && (
        <div className="relative flex flex-col items-center">
          {/* Mensaje encima del botón */}
          <div className="chatbot-message p-2 shadow-md text-sm animate-zoommsg">
            <a >
              Pregúntame acerca de Mentor-IA
            </a>
          </div>
 
          {/* Botón del chatbot */}
          <div
            id="chatbot-toggle"
            className="chatbot-header chatbot-header-collapsed"
            onClick={() => {
              if (!isChatOpen) {
                if (!userId || !sessionId) {
                  setCurrentStep('welcome');
                }
              }
              toggleChat();
            }}
          >
            {/* Ícono del chatbot cuando está cerrado */}
            <div className="chatbot-closed-icon flex justify-center items-center">
              <img src={logoblanco} alt="Logo Blanco" className="h-12 w-12" />
            </div>
          </div>
        </div>
      )}

      {/* Contenedor del chatbot cuando está abierto */}
      {isChatOpen && (
        <div
          id="chatbot-toggle"
          className="chatbot-header chatbot-header-open"
          onClick={toggleChat}
        >
          {/* Ícono de cerrar cuando el chatbot está abierto */}
          <div className="flex items-center w-full">
            <IoMdCloseCircle className="btn-close" onClick={toggleChat} />
          </div>
        </div>
      )}

      {/* Ventana del chatbot cuando está abierto */}
      {isChatOpen && (
        <div id="chatbot-window" className="chatbot-welcome bg-secondary">
          <div className="text-white text-center space-y-9 mb:space-y-[25%] tabs:space-y-[10%]">
            <div className="text-h4 font-bold mb:text-h1 tabs:text-h3">
              <p>Hola</p>
              <p>Soy YARMIS</p>
            </div>
            <div className="flex justify-center">
              <img src={ImgWelcome} alt="Bot Icon" className="max-w-[30%] h-auto mb:max-w-[60%] tabs:max-w-[45%]" />
            </div>
            <div className="text-body3 font-normal mb:text-h3 tabs:text-h4 mb:w-[100%]">
              <p>Estoy aquí para responder tus dudas sobre Mentor-IA.</p>
            </div>
            <button onClick={() => setCurrentStep('register')} className="btn-chat">
              Comenzar ahora
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Welcome;
